import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const OperationalExcellence = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Operational Excellence</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="operational-excellence-table.png"
              alt="operational-excellence-table"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="operational-excellence-table-mobile.png"
                alt="operational-excellence-table"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OperationalExcellence;
